const green = {
  light: '#EAF5EC',
  /**
   * @deprecated use `success.light`
   */
  100: '#EAF5EC',
  main: '#319942',
  dark: '#277A35',
  /**
   * @deprecated use `success.dark`
   */
  500: '#277A35'
};
export default green;